import { MeasureTextHeightAdv } from "./MeasureTextHeightAdv";

export function MeasureTextHeight(fontString, fontSize, fontIcon) {
  var t = MeasureTextHeightAdv(fontString, fontSize, fontIcon);
  return t.fTxtHeight;
}
